import {GridColDef} from '@mui/x-data-grid';

export const projectColumns: GridColDef[] = [
  {
    field: 'projectLabel',
    headerName: 'Name',
    flex: 1,
    headerClassName: 'typo-text label2_size',
  },
  {
    field: 'clientEntityLabel',
    headerName: 'Client Name',
    flex: 1,
    headerClassName: 'typo-text label2_size',
  },
  {field: 'hcode', headerName: 'Alpha Code', flex: 1},
  {field: 'status', headerName: 'Status', flex: 1},
];
